import { StarRating } from 'components/StarRating/StarRating';

import { useReviews } from 'hooks/review/useReviews';

import { InfoBlock } from './InfoBlock';

import s from './AvgRating.module.css';

type TAvgRatingProps = {
  avgRating: number;
};

export const AvgRating = ({ avgRating }: TAvgRatingProps) => {
  const { reviews } = useReviews();

  const scrollToReviews = () => {
    document
      .getElementById('all-reviews')
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <InfoBlock>
      <div className={s.avgReviews}>
        <StarRating
          value={avgRating}
          fillColor="#FFFFFF"
          emptyColor="rgb(255 255 255 / 35%)"
        />
        <div className={s.reviewCount}>({reviews.length} Reviews)</div>
      </div>
      <div className={s.allReviews}>
        <button onClick={scrollToReviews} type="button">
          See all reviews
        </button>
      </div>
    </InfoBlock>
  );
};
